/** Last chat the user had open, so the sidebar's Chat link returns to it. */
const key = (userId: string) => `chat:lastChat:${userId}`;
/** Key used before the page was renamed from Inicio; read once so the last chat isn't lost. */
const legacyKey = (userId: string) => `inicio:lastChat:${userId}`;

export function getLastChatId(userId: string | undefined): string | null {
  if (!userId) return null;
  try {
    return localStorage.getItem(key(userId)) ?? localStorage.getItem(legacyKey(userId));
  } catch {
    return null;
  }
}

export function setLastChatId(userId: string | undefined, chatId: string | null): void {
  if (!userId) return;
  try {
    localStorage.removeItem(legacyKey(userId));
    if (chatId) localStorage.setItem(key(userId), chatId);
    else localStorage.removeItem(key(userId));
  } catch {
    /* storage unavailable */
  }
}
